import React from 'react';
import SwiperCore, { Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css';
import "../../css/Skills.css";

SwiperCore.use([Autoplay])

const Skills = () => {
const data =[ 
    {
        img:"/images/html" ,
        name: "HTML5"
    },
    
    {
        img:"/images/css" ,
        name: "CSS5"
    },
    {
        img:"/images/js-file" ,
        name: "JAVASCRIPT"
    },
    {
        img:"/images/bootstrap" ,
        name: "BOOTSTRAP"
    },
    {
        img:"/images/sass" ,
        name: "SASS"
    },
    {
        img:"/images/tailwind" ,
        name: "TAILWIND CSS"
    },
    {
        img:"/images/react" ,
        name: "REACT JS"
    },
    {
        img:"/images/Redux" ,
        name: "REACT REDUX"
    },
    {
        img:"/images/node" ,
        name: "NODE JS"
    },
    {
        img:"/images/mongo" ,
        name: "MONGODB"
    },
    {
        img:"/images/visual-basic" ,
        name: "VISUAL STUDIO"
    },
    {
        img:"/images/ps" ,
        name: "PHOTOSHOP"
    },
    {
        img:"/images/XD" ,
        name: "ADOVE XD"
    },

]

    return (
        <div className="skills container px-2">
            <h1 className="skills__heading">MY SKILLS </h1>
           <div className="skills__container">

                {
                    data.map(item => {
                        return (
                            <div data-aos="zoom-in" data-aos-delay="200" key={item.name} className="skills__item">
                                <img className="skills__img" src={`${item?.img}.png`} alt={item} />
                                <span>{item?.name} </span>
                            </div>

                        )
                    })
                }
           </div>
          
        </div>
    )
}

export default Skills;